import React from "react";
import pattern_16 from "../assets/images/background/pattern-16.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import refundOgImage from "../assets/images/resource/about-4.jpg";

const Refund_Policy = () => {
  const canonical = "https://www.swiftmazetech.com/refund-policy/";
  const ogImage = `https://www.swiftmazetech.com${refundOgImage}`;
  const description = "Read SwiftMaze Tech refund and cancellation policy for eligibility, timelines, and payment processing details.";
  return (
    <>
      <Helmet>
        <title>Refund and Cancellation Policy | SwiftMaze Tech</title>
        <meta
          name="description"
          content={description}
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content="Refund and Cancellation Policy | SwiftMaze Tech" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Refund and Cancellation Policy | SwiftMaze Tech" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>
      <section className="page-title">
        <div
          className="pattern-layer-one"
          style={{ backgroundImage: `url(${pattern_16})` }}
        ></div>
        <div className="auto-container">
          <h2>Refund & Cancellation Policy</h2>
          <ul className="page-breadcrumb">
            <li><Link to="/">Home</Link></li>
            <li>Refund Policy</li>
          </ul>
        </div>
      </section>

      <section className="about-section">
        <div className="auto-container">
          <div className="sec-title">
            <div className="title">Refund Policy</div>
            <h2>Transparent & Fair Refund Process</h2>
          </div>

          <div className="privacy-content">
            <h4>Service-Based Refunds</h4>
            <ul>
              <li>Refunds apply only to unused or undelivered services.</li>
              <li>Once work has started, refunds may not be applicable.</li>
              <li>Custom development and digital services are generally non-refundable.</li>
            </ul>

            <h4>Cancellation Policy</h4>
            <ul>
              <li>Cancellation requests must be submitted in writing.</li>
              <li>Requests must be made within 24–48 hours of payment (if work has not started).</li>
              <li>Late cancellations may not be eligible for refunds.</li>
            </ul>

            <h4>Refund Processing</h4>
            <ul>
              <li>Approved refunds are processed within 7–10 business days.</li>
              <li>Refunds are credited to the original payment method.</li>
              <li>Payment gateway processing times may vary.</li>
            </ul>

            <h4>Non-Refundable Cases</h4>
            <ul>
              <li>Completed or partially completed services.</li>
              <li>Delays caused by missing client inputs.</li>
              <li>Third-party tool or license purchases.</li>
            </ul>

            <h4>Payment Gateways</h4>
            <p>
              Payments are securely handled via Razorpay, PhonePe, Paytm, or
              other authorized payment providers. SwiftMaze Tech does not store
              payment credentials.
            </p>

            <h4>Contact</h4>
            <p>
              For refund or cancellation requests, please contact us through our
              website with payment details and order reference.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Refund_Policy;
